
import React from 'react'
import MyNested from './MyNested'
//

export default () => (
  <div>
    <h1>This is what we're all about.</h1>
    <p>React, static sites, performance, speed. It's the stuff that makes us tick.</p>
    <MyNested />
  </div>
)



// WEBPACK FOOTER //
// /projects/test/staticreact/testeroo/src/containers/About.js